import React from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";
import fractionToInt from "../../util/fractionToInt";
import { UnitObj } from "../../util/quoteCartStorage";
import { convertDecimalToFraction } from "../../util/formulas/convertDecimalToFraction";

function useWidthSelection() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorWidth = useStore((state) => state.quote.unitSize);
  const doorWidthFraction = useStore((state) => state.quote.unitSizeFraction);

  const windowWidth = useStore((state) => state.quote.comboWindowUnitSize);
  const windowWidthFraction = useStore(
    (state) => state.quote.comboWindowUnitSizeFraction,
  );

  const handleError = useStore((state) => state.handleError);

  const errors = useStore((state) => state.errors);

  const showError = (unitType: string, overall: number, key: string) => {
    let err = "";

    const max = unitType === "Door" ? 290.125 : 255;
    const min = 38.375;

    const errMsgHigh = "Width can not exceed";
    const errMsgLow = "Width must exceed";

    if (overall > max) {
      err = `${errMsgHigh} ${convertDecimalToFraction(max)}"`;
    } else if (overall < min) {
      err = `${errMsgLow} 38 3/8"`;
    }

    return handleError(key, err);
  };

  const handleWidthChangeDoor = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: Partial<UnitObj> = {
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    };

    if (!num) update["unitSize"] = "";
    else update["unitSize"] = `${num}`;

    addToQuote(update, "unitSize");

    if (num) {
      const overallWidth = fractionToInt(value, doorWidthFraction);
      showError("Door", overallWidth, "widthErr");
    }
  };

  const handleWidthChangeWindow = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    const num = parseInt(value);

    let update: Partial<UnitObj> = {
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    };

    if (!num) update["comboWindowUnitSize"] = "";
    else update["comboWindowUnitSize"] = `${num}`;

    addToQuote(update, "comboWindowUnitSize");

    if (num) {
      const overallWidth = fractionToInt(value, windowWidthFraction);
      showError("Window", overallWidth, "widthErrComboWindow");
    }
  };

  const handleFractionChangeDoor = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ unitSizeFraction: "" });

    addToQuote({
      unitSizeFraction: value,
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    });

    const overallWidth = fractionToInt(doorWidth, value);
    showError("Door", overallWidth, "widthErr");
  };

  const handleFractionChangeWindow = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value === null) return addToQuote({ comboWindowUnitSizeFraction: "" });

    addToQuote({
      comboWindowUnitSizeFraction: value,
      jamb: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
    });

    const overallWidth = fractionToInt(windowWidth || "", value);
    showError("Window", overallWidth, "widthErrComboWindow");
  };

  const overallWidth = 
    !doorWidth || !windowWidth 
    ? 0
    : convertDecimalToFraction(fractionToInt(doorWidth, doorWidthFraction || "") + fractionToInt(windowWidth, windowWidthFraction || ""))

  return {
    handleWidthChangeDoor,
    handleFractionChangeDoor,
    handleFractionChangeWindow,
    handleWidthChangeWindow,
    widthErrWindow: errors.widthErrComboWindow,
    widthErrDoor: errors.widthErr,
    doorWidth,
    windowWidth,
    doorWidthFraction,
    windowWidthFraction,
    overallWidth
  };
}

export default useWidthSelection;
